module.exports = __webpack_public_path__ + "img/art_1_5.ea7ed6af.jpg";